import React from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp';
//import Signup from './../components/signup.js'

// import logo from '../img/logo.svg'
// import facebook from '../img/social/facebook.svg'
// import instagram from '../img/social/instagram.svg'
// import linkedin from '../img/social/linkedin.svg'
// import twitter from '../img/social/twitter.svg'

// let messageText = document.querySelectorAll('.message-e');
const Footer = class extends React.Component {
  state = {
    name: null,
    email: null,
  }

  _handleChange = (e) => {
      console.log({
          [`${e.target.name}`]: e.target.value,
      });
      this.setState({
          [`${e.target.name}`]: e.target.value,
      });
  }

  _handleSubmit = (e) => {
      e.preventDefault();

      console.log('submit', this.state);

      addToMailchimp(this.state.email, this.state)
          .then(({ msg, result }) => {
              console.log('msg', `${result}: ${msg}`);

              if (result !== 'success') {
                  throw msg;
              }
              // messageText.innerHTML = err;
              alert(msg);
          })
          .catch((err) => {
              console.log('err', err);
              //messageText.innerHTML = err;
              alert(err);
          });
  }

  render() {
    return (
      <footer className="footer grid push">
        <div className="grid--item">
          <p>
          Subscribe to The Genius List Newsletter
          </p>
          <form onSubmit={this._handleSubmit}>  
            <input
                type="email"
                onChange={this._handleChange}
                placeholder="your@email.com"
                name="email"
            />
            <input 
              type="submit"
              placeholder="→"
            />
          </form>
            <div className="message-e"></div>
        </div>
        <div className="grid--item">
          <p>
          <a title="instagram" href="https://instagram.com/thegeniuslist">
            Instagram
            {/* <img
              className="fas fa-lg"
              src={instagram}
              alt="instagram"
              style={{ width: '1em', height: '1em' }}
            /> */}
          </a>,&nbsp;
          <a title="facebook" href="https://facebook.com/thegeniuslist">
            Facebook
            {/* <img
              src={facebook}
              alt="Facebook"
              style={{ width: '1em', height: '1em' }}
            /> */}
          </a>,&nbsp;
          <a title="twitter" href="https://twitter.com/thegeniuslist1">
            Twitter
            {/* <img
              src={twitter}
              alt="twitter"
              style={{ width: '1em', height: '1em' }}
            /> */}
          </a>,&nbsp;
          <a title="linkedin" href="https://www.linkedin.com/company/35496437">
            Linkedin
            {/* <img
              className="fas fa-lg"
              src={linkedin}
              alt="linkedin"
              style={{ width: '1em', height: '1em' }}
            /> */}
          </a>
          </p>
        </div>
        {/*  < div className="message-one rotate">Expand your mind</div-->
         < div className="message-two rotate">Expand your community</div>  */}
        <blockquote></blockquote>
      </footer>
    )
  }
}

export default Footer
